import React from "react";
import styled from "styled-components";

export default function About() {
  return (
    <StyledAbout>
      <main className="main">
        <div className="about">
          <div className="container mt-sm-5 mb-5">
            <div className="row justify-content-center">
              <div className="col-lg-8 lh-lg">
                <h1 className="mb-5">О проекте</h1>
                <h2>Что такое Мы</h2>
                <p>
                  Это открытый бесплатный проект для изучения основ
                  программирования. Интерактивные курсы с практикой рассчитаны
                  на тех, кто только начал интересоваться разработкой. На Мы уже
                  есть курсы по PHP, Java, JS, Python, Ruby, HTML, CSS, Racket,
                  Elixir и Go.
                </p>
                <p>
                  В 2020 году проект Мы занял 3 место на Международном конкурсе
                  открытых онлайн-курсов EdCrunch Award OOC в номинации «Лучший
                  внеплатформенный онлайн-курс».
                </p>
                <h2>Почему мы его создали</h2>
                <p>
                  Большинство доступных материалов для новичков больше похожи на
                  справочники или туториалы в стиле «повтори за учителем».
                </p>
                <p>
                  Цель проекта Мы — грамотный старт. Мы хотим научить начинающих
                  программистов лучшим стандартам кодирования, правильному
                  именованию функций, пониманию систем, а не запоминанию
                  специфики.
                </p>
                <h2>Для кого наш проект</h2>
                <ul className="about_list">
                  <li>
                    Для новичков, которые только начинают знакомиться с
                    синтаксисом языков программирования и базовыми алгоритмами.
                  </li>
                  <li>
                    Для начинающих программистов, которые «плавают» в основах и
                    хотят узнать больше, чем написано в учебниках.
                  </li>
                  <li>Для учителей, работающих с новичками.</li>
                </ul>
                <h2>Как можно поучаствовать в его разработке</h2>
                <p>
                  Мы - это собственный Open Source проект команды Мыа. Любой
                  программист может поучаствовать в его разработке: улучшить
                  уроки, исправить неточности и расширить курсы на другие языки
                  программирования. Вакансии платформы Мы, всех уроков и
                  упражнений доступен на GitHub.
                </p>
                <a
                  className="about_link"
                  target="_blank"
                  href="https://github.com/hexlet-basics"
                  rel="noreferrer"
                >
                  <span className="me-2 bi bi-github"></span>
                  <span>Вакансии</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </StyledAbout>
  );
}

const StyledAbout = styled.div`
  .about_link {
    color: #0d6efd;

    &:hover {
      color: rgb(10 88 202);
    }
  }
  .about_list {
    list-style-type: decimal;
  }
`;
